<div class="container">
  <section class="main">
    <div class="main-row">
      <div class="main-title">
        <span
          class="text-hover-animation">Запусти бизнес</span> <br>
        <span class="text-hover-animation">по&nbsp;самокатам</span>
        <br> в своем городе
      </div>
      <div class="main-app-container">
        <a href="https://play.google.com/store/apps/details?id=soft.gelios.com.scooter" class="main-app-android">
          <img src="../../../assets/img/app-android.svg" alt="icon">
        </a>
        <a href="https://apps.apple.com/us/app/busyfly/id1488207086?l=ru" class="main-app-iphone">
          <img src="../../../assets/img/app-iphone.svg" alt="icon">
        </a>
      </div>
      <div class="main-social-networks">
        <a href="https://www.instagram.com/busyfly_sharing/" class="main-social-item instagram-icon"> </a>
        <a href="https://www.facebook.com/busyflysharing" class="main-social-item facebook-icon"> </a>
      </div>
    </div>

    <div class="main-row-images">
      <img id="cloud" class="cloud-group" src="../../../assets/img/clouds/cloud-group-2.svg" alt="image">
      <div class="img"></div>
      <div class="img-grass"></div>
      <div class="img-small-tree-stem"></div>
      <img class="img-small-tree" src="../../../assets/img/main-small-tree.svg" alt="image">
      <img class="img-tree" src="../../../assets/img/main-tree.svg" alt="image">
      <div class="img-tree-stem"></div>
      <img class="img-hair" src="../../../assets/img/main-hair.svg" alt="image">
      <img class="img-girl-with-scooter" src="../../../assets/img/main-girl-with-scooter.svg" alt="image">
      <img class="img-strand-of-hair" src="../../../assets/img/main-strand-of-hair.svg" alt="image">
      <img class="img-main-bag" src="../../../assets/img/main-bag.svg" alt="image">
      <img class="img-hand" src="../../../assets/img/main-hand.svg" alt="image">
      <img class="img-leg" src="../../../assets/img/main-leg.svg" alt="image">
      <img class="img-wheel-left" src="../../../assets/img/main-wheel.svg" alt="image">
      <img class="img-wheel-right" src="../../../assets/img/main-wheel.svg" alt="image">
    </div>
  </section>
</div>
